{
  "title": "Deposit {{number}}",
  "backToList": "Deposits",
  "sections": {
    "summary": "Deposit summary",
    "employees": "Employees and times",
    "messages": "WhatsApp messages",
    "prints": "Printing"
  },
  "language": "Depositor language",
  "languageName": {
    "ar": "Arabic",
    "en": "English"
  },
  "cancelReason": "Cancellation reason",
  "created": "Created By",
  "cancelledBy": "Cancelled by",
  "documentPhoto": "Document photo",
  "notDelivered": "Not delivered yet",
  "noMessages": "No messages for this deposit",
  "noPrints": "The receipt has not been printed",
  "print": {
    "first": "Print",
    "reprint": "Reprint",
    "PRINTED": "Done",
    "FAILED": "Failed"
  },
  "template": {
    "deposit_created_depositor": "Deposit notice to the depositor",
    "deposit_created_recipient": "Deposit notice to the recipient",
    "deposit_delivered": "Delivery notice",
    "deposit_returned": "Return notice"
  },
  "noHistory": "No edits",
  "oldValue": "Old value",
  "newValue": "New value",
  "editField": {
    "amount": "Amount",
    "currency": "Currency",
    "location": "Storage location",
    "notes": "Notes",
    "depositor.fullName": "Depositor: full name",
    "depositor.phone": "Depositor: phone",
    "depositor.documentType": "Depositor: document type",
    "depositor.documentNumber": "Depositor: document number",
    "depositor.documentCountry": "Depositor: issuing country",
    "intendedRecipient.fullName": "Intended recipient: full name",
    "intendedRecipient.phone": "Intended recipient: phone",
    "actualRecipient.fullName": "Actual recipient: full name",
    "actualRecipient.phone": "Actual recipient: phone",
    "actualRecipient.documentType": "Actual recipient: document type",
    "actualRecipient.documentNumber": "Actual recipient: document number",
    "actualRecipient.documentCountry": "Actual recipient: issuing country"
  },
  "referralStatus": {
    "PENDING": "Awaiting supervisor review",
    "APPROVED": "Approve",
    "REJECTED": "Reject"
  },
  "failureGeneric": "The message could not be sent. Try again later.",
  "failureCodes": {
    "1": "The WhatsApp provider service is temporarily unavailable",
    "2": "The WhatsApp provider service is temporarily unavailable",
    "4": "The request limit was exceeded, try again later",
    "100": "The message data is invalid",
    "130429": "The message rate limit was exceeded, try again later",
    "131000": "An unexpected error occurred at the WhatsApp provider",
    "131026": "The message could not be delivered: the number is not on WhatsApp or does not accept messages",
    "131030": "The recipient number is not allowed to receive messages",
    "131042": "There is a payment problem with the WhatsApp Business account",
    "131047": "The conversation window has expired, a new template must be sent",
    "131048": "Sending is restricted because too many messages were rejected",
    "131049": "The message was not delivered to protect engagement quality with the recipient",
    "131053": "The message image upload failed, check the image",
    "131056": "The message limit for this recipient was exceeded, try again later",
    "132000": "The number of template variables does not match the approved template",
    "132001": "The template does not exist or is not approved in this language",
    "132005": "The translated template text is too long",
    "132012": "The template variable values are invalid",
    "190": "The WhatsApp account connection has expired and must be renewed"
  },
  "phoneRefusedByCustomers": "Customers refused this number; edit the phone"
}
